import { render, staticRenderFns } from "./editQuestion.vue?vue&type=template&id=673e830c"
import script from "./editQuestion.vue?vue&type=script&lang=js"
export * from "./editQuestion.vue?vue&type=script&lang=js"
import style0 from "./editQuestion.vue?vue&type=style&index=0&id=673e830c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports